export const INDEXING_ERROR_CODE = 'ALREADY_INDEXING';

export const PUSH_CONFIG = window.__DATA__.push;

export const INSTALLATION_TYPE =
    window.__DATA__.appInstallation === 'business' ? 'external' : 'internal';
export const IS_INTERNAL = INSTALLATION_TYPE === 'internal';
export const IS_EXTERNAL = INSTALLATION_TYPE === 'external';

export const LANG = window.__DATA__.lang;
export const IS_MOBILE = window.__DATA__.isMobile;
export const NOTIFICATIONS_HOST = window.__DATA__.notificationsHost;
export const REQ_ID = window.__DATA__.reqid;
export const APP_ENV = window.__DATA__.env;

export const __DEV__ = process.env.NODE_ENV === 'development';
export const __PROD__ = process.env.NODE_ENV === 'production';
export const NONCE = window.__DATA__.nonce;

export const SERVICE_DESK_LINK = 'https://help.yandex-team.ru';
export const SETTINGS_PAGE = '_settings';
export const HOME_PAGE_SLUG = 'homepage';

export const YANDEX_LINK = 'https://ya.ru';
export const CONFIDENTIALITY_LINK = 'https://wiki.yandex-team.ru/security/nda/';
// TODO: Руками залил статику. Надо придумать как автоматом прокидывать версию.
export const MERMAID_RUNTIME_PATH =
    'https://wiki.s3.mds.yandex.net/%40yandex-int/wiki/_/mermaid-static/mermaid-1.1.1.js';

// Для возможности использовать новые иллюстрации
type StatusIllustrationVersion = 'v1' | 'v2';
const v2: StatusIllustrationVersion = 'v2';
export const STATUS_ILLUSTRATION_CONTEXT = {
    version: v2,
    bucketUrl: 'https://storage.yandexcloud.net/console-static/illustrations-v2',
};

export {DOC_LINKS} from './docs';
export {APIErrorCodes} from './errors';
export {IS_MAC} from './platform';
